import { render, staticRenderFns } from "./ComplexPc.vue?vue&type=template&id=2d4f1c55&scoped=true"
import script from "./ComplexPc.vue?vue&type=script&lang=js"
export * from "./ComplexPc.vue?vue&type=script&lang=js"
import style0 from "./ComplexPc.vue?vue&type=style&index=0&id=2d4f1c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f1c55",
  null
  
)

export default component.exports